import Modal from '@/components/Modal';
import { Button } from '@odekoteam/doppio';
import { Flex, Heading } from 'theme-ui';

export function UnsavedChangesModal({
  toggle,
  visible,
  handleClose,
}: {
  visible: boolean;
  toggle: () => void;
  handleClose: () => void;
}) {
  return (
    <Modal visible={visible}>
      <Heading variant="headingMd" sx={{ mb: 3 }}>
        Unsaved Changes
      </Heading>
      <Flex sx={{ gap: 4, flexDirection: 'column' }}>
        <div>
          You have unsaved changes. Are you sure you want to leave without
          saving them?
        </div>
        <Flex sx={{ gap: 3, justifyContent: 'flex-end' }}>
          <Button variant="ghost" onPress={() => handleClose()}>
            Leave and clear
          </Button>
          <Button onPress={toggle}>Stay and review</Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
